import type Decimal from 'decimal.js';
import numeral from 'numeral';

/**
 * Returns a string with commas and without $
 * @param value Decimal
 * @returns string
 */
export function formatDecimalToCurrency(value: Decimal): string {
  return numeral(value.toString()).format('0,0.00');
}
